module.exports = __webpack_public_path__ + "img/w3_percent_black.76cac7e6.png";